import {DatePicker} from 'antd'
import {baseFieldTypes} from 'apis/base/baseFieldTypes'
import useTranslate from 'modules/local/useTranslate'
import React, {useCallback} from 'react'
import {IoCalendarOutline} from 'react-icons/io5'
import {NullAsDefault} from 'views/Shared'
import dayjs from "dayjs";
import {ChipGroup, Field} from "../../../components/form/ModernForm";
import {Chip, SectionLabel} from "../../AppLocals/Directory/filters/DirectoryFilterUI";
import {DioceseTypeCodes} from "../../AppLocals/appFieldTypes";
import classNames from "classnames";

const FilterChip = ({active, onClick, children}) => (
    <button
        type="button"
        onClick={onClick}
        style={{minHeight: 30}}
        className={classNames(
            'px-3 py-1 flex flex-center flex-shrink-0 gap-1 rounded-lg text-sm font-semibold transition-all cursor-pointer',
            active
                ? 'bg-secondary-500 text-white'
                : 'background shadow-sm hover:shadow-md text-slate-600 border border-color-50 hover:border-secondary-500 hover:text-secondary-500'
        )}>
        {children}
    </button>
)

const MedalFilter = ({
                         owner_id,
                         owner_type,
                         value: filter = {
                             active: undefined,
                         },
                         onChange: setValues = NullAsDefault,
                     }) => {
    const t = useTranslate()

    const handleChange = useCallback(
        (name, value) => {
            setValues({
                ...filter,
                [name]: value,
            })
        },
        [filter]
    )

    // filter.active đến từ query param trên URL nên luôn là string ("0" | "1").
    // withSearchParams() xoá param khi value falsy => phải gửi string, không gửi number 0.
    const activeValue = filter?.active == null ? undefined : String(filter.active)
    const isAll = activeValue === undefined || activeValue === ''

    return (
        <div className="flex flex-col gap-1">
            <span className="font-medium text-2xs text-slate-400 uppercase tracking-wider">
                {t('status')}
            </span>
            <div className="flex flex-wrap gap-2">
                <FilterChip active={isAll} onClick={() => handleChange('active', undefined)}>
                    {t('all')}
                </FilterChip>
                {baseFieldTypes.active.map((e) => (
                    <FilterChip
                        key={e.value}
                        active={!isAll && activeValue === String(e.value)}
                        onClick={() => handleChange('active', String(e.value))}>
                        {t(e.label)}
                    </FilterChip>
                ))}
            </div>
        </div>
    )
}

export const MedalAwardFilter = ({
                                     value: filter = {
                                         to_date: undefined,
                                         from_date: undefined,
                                     },
                                     onChange: setValues = NullAsDefault,
                                 }) => {
    const t = useTranslate()

    const handleChange = useCallback(
        (name, value) => {
            setValues({
                ...filter,
                [name]: value,
            })
        },
        [filter]
    )

    return (
        <div className="flex flex-col md:flex-row items-center gap-2 mt-2">
            <DatePicker
                allowClear={true}
                suffixIcon={<IoCalendarOutline className="text-color-500"/>}
                onChange={(date, dateString) => {
                    handleChange('from_date', dateString)
                }}
                format="YYYY-MM-DD"
                defaultValue={
                    filter.from_date ? dayjs(new Date(filter.from_date)) : undefined
                }
                placeholder={t('from date')}
            />
            <DatePicker
                allowClear={true}
                suffixIcon={<IoCalendarOutline className="text-color-500"/>}
                onChange={(date, dateString) => {
                    handleChange('to_date', dateString)
                }}
                format="YYYY-MM-DD"
                defaultValue={
                    filter.to_date ? dayjs(new Date(filter.to_date)) : undefined
                }
                placeholder={t('to date')}
            />
        </div>
    )
}

export default MedalFilter
